export default "__VITE_ASSET__VpzDriwy__"